import { ForcedIdeationFormState } from '@/components/forced-ideation/utils/form';

const STORAGE_KEY = 'forcedIdeation.TemporalStorage';

export const forcedIdeationTemporalStorage = {
  save(form: ForcedIdeationFormState): void {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(form));
  },
  load(): Partial<ForcedIdeationFormState> | null {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === null) return null;
    try {
      return JSON.parse(stored);
    } catch {
      // 壊れた値が残っていた場合は無視して復元しない
      return null;
    }
  },
  clear(): void {
    sessionStorage.removeItem(STORAGE_KEY);
  },
};
